import classNames from 'classnames';
import { TrustpilotFallback } from 'components/TrustpilotSection/TrustpilotFallback';
import dynamic from 'next/dynamic';
import { useState } from 'react';

import styles from './TrustpilotSection.module.scss';

interface TrustpilotSectionProps {
  locale: Locale;
  templateId: string;
  width: string;
  height: number;
  className?: string;
}

// SSR disabled to prevent hydration issues with third-party Trustpilot script
const TrustpilotWidget = dynamic(() => import('./TrustpilotWidget'), {
  ssr: false,
});

export const MICROSTAR_WIDGET = '5419b732fbfb950b10de65e5';
export const MICROCOMBO_WIDGET = '5419b6ffb0d04a076446a9af';

export const TrustpilotSection = ({
  locale,
  templateId,
  width,
  height,
  className,
}: TrustpilotSectionProps) => {
  const [widgetLoaded, setWidgetLoaded] = useState(false);

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.microstarWrapper]: templateId === MICROSTAR_WIDGET,
      })}
      style={{ height: `${height}px` }}
    >
      {!widgetLoaded && <TrustpilotFallback height={height} />}
      <TrustpilotWidget
        locale={locale}
        templateId={templateId}
        width={width}
        height={height}
        className={className}
        onLoad={() => setWidgetLoaded(true)}
      />
    </div>
  );
};
